<template>
  <div style="height: 100%">
    <div style="padding: 20px; height: 800px">
      <el-form
        :inline="true"
        :model="params"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="调拨批次号">
          <el-input v-model="params.batchNo" placeholder="请输入调拨批次号" clearable></el-input>
        </el-form-item>
        <el-form-item label="充电桩编号">
          <el-input v-model="params.deviceNum" placeholder="请输入充电桩编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属类型">
          <el-select filterable clearable v-model="params.categoryId" placeholder="请选择类型">
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-select filterable clearable v-model="params.companyId" placeholder="请选择公司">
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-select filterable clearable v-model="params.regionId" placeholder="请选择区域">
            <el-option
              v-for="item in regionList"
              :key="item.id"
              :label="item.regionName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调拨人">
          <el-select filterable clearable v-model="params.transferUser" placeholder="请选择调拨人">
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调拨时间">
          <el-date-picker
            style="width: 320px"
            v-model="transferTimeRange"
            type="datetimerange"
            range-separator="至"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="checkData" type="primary" size="mini">查询</el-button>
          <el-button type="info" @click="reset" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="height: 82%; background-color: #fff; border-radius: 8px">
        <el-table
          :data="tableData"
          stripe
          style="padding-top: 20px; width: 96%; margin-left: 15px"
          height="80%"
          size="small"
          :header-cell-style="{
            'background-color': '#84aace4a',
            color: '#343333',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column prop="batchNo" label="调拨批次号" min-width="180"></el-table-column>
          <el-table-column prop="deviceNum" label="充电桩编号" min-width="140"></el-table-column>
          <el-table-column prop="categoryName" label="所属类型" min-width="120"></el-table-column>
          <el-table-column prop="companyName" label="所属公司" min-width="120"></el-table-column>
          <el-table-column prop="regionName" label="所属区域" min-width="100"></el-table-column>
          <el-table-column prop="status" label="调拨时状态" width="100" :formatter="statusFormat"></el-table-column>
          <el-table-column prop="isBad" label="是否坏桩" width="90" :formatter="isBadFormat"></el-table-column>
          <el-table-column prop="haveUserName" label="拥有人" min-width="100"></el-table-column>
          <el-table-column prop="remark" label="调拨备注" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="调拨凭证" width="90">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.attachmentIds"
                type="text"
                size="mini"
                @click="seeFileList(scope.row.attachmentIds.split(','))"
              >{{ scope.row.attachmentIds.split(',').length }}</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="transferUserName" label="调拨人" min-width="100"></el-table-column>
          <el-table-column
            prop="transferTime"
            label="调拨时间"
            min-width="160"
            :formatter="(row) => timeFormat(row.transferTime)"
          ></el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="分配历史" placement="top-end">
                <el-button
                  type="primary"
                  icon="el-icon-document"
                  circle
                  size="mini"
                  @click="distributeHistoryOpen(scope.row.deviceId)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            padding-top: 20px;
            height: 40px;
            background-color: #fff;
            width: 100%;
            border-radius: 8px;
            text-align: right;
          "
        >
          <el-pagination
            background
            :page-sizes="sizes"
            layout="total,sizes,prev,pager,next"
            :total="total"
            :current-page.sync="params.page"
            :page-size.sync="params.size"
            @current-change="handleCurrentChange"
            @size-change="sizeChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <DistributeHistory ref="distributeHistory" />
    <FileList ref="fileListRefs"></FileList>
  </div>
</template>

<script>
import moment from "moment";
import DistributeHistory from "@/components/admin/device/components/DistributeHistory";
import FileList from "@/components/FileList";

export default {
  components: { DistributeHistory, FileList },
  data() {
    return {
      tableData: [],
      classList: [],
      companyDrownList: [],
      regionList: [],
      allUserList: [],
      transferTimeRange: [],
      params: {
        batchNo: "",
        deviceNum: "",
        categoryId: "",
        companyId: "",
        regionId: "",
        transferUser: "",
        page: 1,
        size: 10,
      },
      total: 0,
      sizes: [10, 15, 20, 50],
    };
  },
  created() {
    this.queryClassList();
    this.getCompanyDrown();
    this.queryRegionList();
    this.queryAllUserList();
    this.queryTransferHistoryList();
  },
  methods: {
    seeFileList(ids) {
      this.$refs.fileListRefs.open(ids);
    },
    distributeHistoryOpen(deviceId) {
      if (!deviceId) {
        this.$message.error("缺少原充电桩ID，无法查看分配历史");
        return;
      }
      this.$refs.distributeHistory.open(deviceId);
    },
    buildQueryParams() {
      const queryParams = { ...this.params };
      if (this.transferTimeRange && this.transferTimeRange.length > 0) {
        queryParams.beginTransferTime = this.transferTimeRange[0];
        if (this.transferTimeRange.length > 1) {
          queryParams.endTransferTime = this.transferTimeRange[1];
        }
      }
      return queryParams;
    },
    queryTransferHistoryList() {
      this.axios({
        method: "get",
        url: "/v1/web/device-manage/list-device-upstream-transfer-history",
        params: this.buildQueryParams(),
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.total = res.data.data.total || 0;
        }
      });
    },
    queryClassList() {
      this.axios({
        method: "get",
        url: "/v1/web/device-category/select-category",
        params: { page: 1, size: 1000 },
      }).then((res) => {
        this.classList = res.data.data.list || [];
      });
    },
    getCompanyDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company-drown",
      }).then((res) => {
        this.companyDrownList = res.data.data || [];
      });
    },
    queryRegionList() {
      this.axios({
        method: "get",
        url: "/v1/web/region-manage/select-region-for-device-form",
      }).then((res) => {
        this.regionList = res.data.data.list || [];
      });
    },
    queryAllUserList() {
      Promise.all([
        this.axios({
          method: "get",
          url: "/v1/web/user-info/select-user-drown",
        }),
        this.axios({
          method: "get",
          url: "/v1/web/user-info/select-master-drown",
        }),
      ]).then(([userRes, masterRes]) => {
        const userList = (userRes.data.data && userRes.data.data.list) || [];
        const masterList = (masterRes.data.data && masterRes.data.data.list) || [];
        const merged = [...userList, ...masterList];
        const seen = new Set();
        this.allUserList = merged.filter((item) => {
          if (seen.has(item.id)) {
            return false;
          }
          seen.add(item.id);
          return true;
        });
      });
    },
    statusFormat(row) {
      if (row.status === 0) {
        return "未使用";
      }
      if (row.status === 1) {
        return "已使用";
      }
      if (row.status === 2) {
        return "转借中";
      }
      return "";
    },
    isBadFormat(row) {
      if (row.isBad === 1) {
        return "是";
      }
      if (row.isBad === 0) {
        return "否";
      }
      return "";
    },
    timeFormat(time) {
      if (time !== null && time !== undefined) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.queryTransferHistoryList();
    },
    sizeChange(val) {
      this.params.size = val;
      this.params.page = 1;
      this.queryTransferHistoryList();
    },
    checkData() {
      this.params.page = 1;
      this.queryTransferHistoryList();
    },
    reset() {
      this.transferTimeRange = [];
      this.params = {
        batchNo: "",
        deviceNum: "",
        categoryId: "",
        companyId: "",
        regionId: "",
        transferUser: "",
        page: 1,
        size: 10,
      };
      this.queryTransferHistoryList();
    },
  },
};
</script>

<style scoped>
</style>
